import PropTypes from 'prop-types'
import styles from './general.module.scss'
import React, { useContext, useState } from 'react'
import ApiContext from '../../utils/api-context'
import Location from '../maps/location'

const MapOverlay = ({ onClose, location, title }) => {
  const [closing, setClosing] = useState(false)
  const { apiUrl, cdnUrl } = useContext(ApiContext)

  // console.log(location)

  const closePopup = () => {
    setClosing(true)
    setTimeout(() => {
      onClose(false)
    }, 250)
  }

  return (
    <div className={`${styles.popup}`}>
      <div
        className={`${styles.popupWrapper} ${styles.popupWrapperLarge} ${
          closing ? styles.closing : ''
        }`}
      >
        <div className={`${styles.popupInner}`}>
          <div className={`${styles.popupHeader}`}>
            <h2 className={`${styles.popupHeaderText}`}>{title}</h2>
            <span className={`${styles.popupClose}`} onClick={closePopup} />
          </div>
          <div className={`${styles.popupContent}`}>
            <div className={`${styles.overview}`}>
              <div className={`${styles.map}`}>
                <Location lat={location.lat} lng={location.lng} name={title} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
MapOverlay.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  location: PropTypes.object,
}
export default MapOverlay
